// src/context/siteConfig.js
// Firestore config/site ドキュメントをリアルタイム購読し、サイト設定を配信する
import React, { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../api/firebase";

export const SITE_DEFAULTS = {
  // 参拝可能距離（メートル）
  visitRadiusM: 50,
};

const SiteConfigContext = createContext(SITE_DEFAULTS);

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(SITE_DEFAULTS);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, "config", "site"),
      (snap) => {
        if (snap.exists()) {
          setConfig({ ...SITE_DEFAULTS, ...snap.data() });
        }
      },
      (err) => {
        console.warn("サイト設定の読み込みに失敗:", err);
      }
    );
    return unsub;
  }, []);

  return (
    <SiteConfigContext.Provider value={config}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
